import { render, staticRenderFns } from "./InteractionStudio.vue?vue&type=template&id=4ccd8e63&"
import script from "./InteractionStudio.vue?vue&type=script&lang=js&"
export * from "./InteractionStudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports